import * as Yup from 'yup';

import { Strings } from '@app/constants';

// ----------------Add Client----------------
export const addClientSchema = Yup.object()
  .shape({
    firstName: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.firstName)),
    lastName: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.lastName)),
    phone: Yup.string().trim(),
    email: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.email))
      .email(Strings.validation.invalidEmail),
    companyName: Yup.string(),
  })
  .required();
